var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.wrapClasses }, [
    _c("div", { class: _vm.outerClasses }, [
      _c("div", { class: _vm.innerClasses }, [
        _c("div", { class: _vm.bgClasses, style: _vm.bgStyle }, [
          _vm.textInside
            ? _c("div", { staticClass: "ivu-progress-inner-text" }, [
                _vm._v(_vm._s(_vm.percent) + "%")
              ])
            : _vm._e()
        ]),
        _c("div", { class: _vm.successBgClasses, style: _vm.successBgStyle })
      ])
    ]),
    _vm._v(" "),
    !_vm.hideInfo && !_vm.textInside
      ? _c(
          "span",
          { class: _vm.textClasses },
          [
            _vm._t("default", function() {
              return [
                _vm.isStatus
                  ? _c(
                      "span",
                      { class: _vm.textInnerClasses },
                      [_c("Icon", { attrs: { type: _vm.statusIcon } })],
                      1
                    )
                  : _c("span", { class: _vm.textInnerClasses }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.percent) +
                          "%\n            "
                      )
                    ])
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27b213b6", { render: render, staticRenderFns: staticRenderFns })
  }
}